"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unobserve = exports.observe = void 0;
const error_1 = require("./error");
const lib_1 = require("./lib");
const getSubjectInstance = (verb, target) => {
    if (typeof (target) !== 'object') {
        throw new error_1.EcceError(`Invalid target: "${target}".`);
    }
    const subject = lib_1.SubjectInstance.getOrNull(target);
    if (!subject) {
        const ctorName = Object.getPrototypeOf(target).constructor.name;
        // Bare object.
        if (!ctorName || ctorName === 'Object') {
            throw new error_1.EcceError(`Cannot ${verb} an object not created by makeSubject().`);
        }
        // Class instance.
        throw new error_1.EcceError(`Cannot ${verb} an instance of a class without a @subject() decorator: "${ctorName}".`);
    }
    return subject;
};
const getPropertyInstance = (verb, target, key) => {
    const subject = getSubjectInstance(verb, target);
    const prop = subject.getProperty(key);
    if (!prop) {
        if (key in target) {
            throw new error_1.EcceError(`Cannot ${verb} a property without an @observable() decorator: "${subject.name}.${String(key)}".`);
        }
        throw new error_1.EcceError(`Cannot ${verb} non-existant property: "${subject.name}.${String(key)}"`);
    }
    return prop;
};
const observe = (target, keyOrCallback, callbackOrOptions, options) => {
    // Observing whole subject.
    if (typeof (keyOrCallback) === 'function') {
        getSubjectInstance('observe', target)
            .observe(keyOrCallback, callbackOrOptions);
        return;
    }
    // Observing a property.
    getPropertyInstance('observe', target, keyOrCallback)
        .observe(callbackOrOptions, options);
};
exports.observe = observe;
const unobserve = (target, keyOrCallback, callback) => {
    // Unobserving whole subject.
    if (typeof (keyOrCallback) === 'function') {
        getSubjectInstance('unobserve', target)
            .unobserve(keyOrCallback);
        return;
    }
    // Unobserving a property.
    getPropertyInstance('unobserve', target, keyOrCallback)
        .unobserve(callback);
};
exports.unobserve = unobserve;
//# sourceMappingURL=observation.js.map